import React, { useEffect, useState } from "react";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
  GridActionsCellItem,
} from "@mui/x-data-grid";
import {
  Box,
  Typography,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import PricingAdviceDialog from "./PricingAdviceDialog";
import SalesDataGridEnhanced from "./SalesDataGridEnhanced";

function CustomToolbar() {
  return (
    <GridToolbarContainer>
      <GridToolbarExport csvOptions={{ fileName: "summary_data" }} />
    </GridToolbarContainer>
  );
}

function SummaryData() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [adviceDialogOpen, setAdviceDialogOpen] = useState(false);
  const [adviceSummaryId, setAdviceSummaryId] = useState(null);

  useEffect(() => {
    const fetchSummary = async () => {
      try {
        const res = await fetch("/api/summary-data");
        const json = await res.json();
        setRows(json);
      } catch (err) {
        console.error("Failed to load summary data", err);
      } finally {
        setLoading(false);
      }
    };
    fetchSummary();
  }, []);

  const handleViewClick = (row) => {
    setSelectedRow(row);
    setDialogOpen(true);
  };

  const handleAdviceClick = (row) => {
    setAdviceSummaryId(row.id);
    setAdviceDialogOpen(true);
  };

  const columns = [
    { field: "id", headerName: "ID", width: 70 },
    { field: "card_name", headerName: "Card Name", width: 220 },
    { field: "card_number", headerName: "Number", width: 100 },
    { field: "search_term", headerName: "Search Term", width: 180 },
    { field: "search_term_exclusions", headerName: "Exclusions", width: 150 },
    { field: "average_price_no_shipping", headerName: "Avg (No Ship)", width: 130 },
    { field: "average_price_with_shipping", headerName: "Avg (With Ship)", width: 130 },
    { field: "low_price_no_shipping", headerName: "Low (No Ship)", width: 130 },
    { field: "high_price_no_shipping", headerName: "High (No Ship)", width: 130 },
    { field: "sales_count", headerName: "Sales Count", width: 120 },
    { field: "search_session_id", headerName: "Session ID", width: 110 },
    {
      field: "actions",
      type: "actions",
      width: 100,
      getActions: (params) => [
        <GridActionsCellItem
          icon={<VisibilityIcon />}
          label="View"
          onClick={() => handleViewClick(params.row)}
        />,
        <GridActionsCellItem
          icon={<LightbulbIcon />}
          label="Advice"
          onClick={() => handleAdviceClick(params.row)}
        />,
      ],
    },
  ];

  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="h5" gutterBottom>
        Summary Data
      </Typography>
      <Box sx={{ height: 700, overflowX: 'auto' }}>
        <Box sx={{ minWidth: 1600 }}>
          <DataGrid
            rows={rows}
            columns={columns}
            loading={loading}
            pageSize={10}
            rowsPerPageOptions={[10, 25]}
            components={{ Toolbar: CustomToolbar }}
            getRowId={(row) => row.id}
          />
        </Box>
      </Box>


      <Dialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        maxWidth="xl"
        fullWidth
      >
        <DialogTitle>
          Sales for: {selectedRow?.card_name || ""} (Session {selectedRow?.search_session_id})
        </DialogTitle>
        <DialogContent>
          {selectedRow && (
            <SalesDataGridEnhanced
              cardName={selectedRow.card_name}
              sessionId={selectedRow.search_session_id}
              summaryId={selectedRow.id}
            />
          )}
        </DialogContent>
      </Dialog>

      <PricingAdviceDialog
        summaryId={adviceSummaryId}
        open={adviceDialogOpen}
        onClose={() => setAdviceDialogOpen(false)}
      />
    </Paper>
  );
}

export default SummaryData;
